var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"charge-standard-box"},[_c('ywhz-title-style-card',{attrs:{"title":_vm.$t('menu.menu2'),"subtitle":"Shipping trial calculation"}}),_c('div',{staticClass:"layout-t layout-width"},[_c('ywhz-third-party')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }